import * as React from "react";
import {MockToolProps} from "./types";
import {useCallback, useState} from "react";
import {classNames, layout, PushButton, TextInput} from "@variocube/cube-ui";
import {Tool} from "./Tool";
import {stylesheet} from "typestyle";


export function KeypadTool({mockController, align}: MockToolProps) {
    const [code, setCode] = useState("");

    const handleShowBarcode = useCallback(() => {
        mockController.keypad.enterAccessCode(code);
    }, [code]);

    return (
        <Tool label="Keypad" align={align}>
            <div className={classNames(layout.paddingLarge)}>
                <div className={styles.inputContainer}>
                    <TextInput value={code} onChange={setCode} outline placeholder="Access Code" className={styles.input}/>
                </div>
                <PushButton onClick={handleShowBarcode} primary className={styles.button}>
                    Enter Access Code
                </PushButton>
            </div>
        </Tool>
    )
}

const styles = stylesheet({
    input: {
        width: "16em",
    },
    inputContainer: {
        paddingBottom: "1em",
    },
    button: {
        display: "block",
        width: "100%"
    }
})